package link.erpango.quip.domain.ocr

/**
 * Outcome of a photo capture followed by on-device recognition, as seen by the capture screen.
 */
sealed interface OcrPhotoOutcome {
    /** Recognition finished and produced usable, non-blank text. */
    data class Recognized(val text: String) : OcrPhotoOutcome

    /** Recognition finished without finding any text in the photo. */
    data object Empty : OcrPhotoOutcome

    /** Recognition failed. */
    data class Failed(val error: OcrError) : OcrPhotoOutcome
}

/**
 * Pure classification of an [OcrResult] for the photo capture UI. Kept free of Compose and
 * platform types so the empty/error/success rules can be unit tested from commonTest.
 */
object OcrPhotoText {
    fun outcomeOf(result: OcrResult): OcrPhotoOutcome {
        val error = result.error
        if (error != null) return OcrPhotoOutcome.Failed(error)
        return if (result.text.isBlank()) {
            OcrPhotoOutcome.Empty
        } else {
            OcrPhotoOutcome.Recognized(result.text)
        }
    }
}
